import { render } from "./specialThanks.vue?vue&type=template&id=44c8bea8&scoped=true"
const script = {}

import "./specialThanks.vue?vue&type=style&index=0&id=44c8bea8&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c8bea8"]])

export default __exports__